const threshold = 500; // Threshold in pixels
document.addEventListener("DOMContentLoaded", function () {
    const scrollToTopBtn = document.getElementById("scroll-to-top");
    if (scrollToTopBtn) {

        window.onscroll = function () {
            scrollFunction();
        };

        function scrollFunction() {
            if (document.body.scrollTop > threshold || document.documentElement.scrollTop > threshold) {
                scrollToTopBtn.classList.add("show");
            } else {
                scrollToTopBtn.classList.remove("show");
            }
        }

        scrollToTopBtn.addEventListener("click", function () {
            window.scrollTo({top: 0, behavior: 'smooth'});
        });
    } else {
        console.log("Element with ID 'scroll-to-top' not found.");
    }
});


